import { IconEditWhite } from "../../assets/icons";
import { extractTextFromChildren, htmlParser } from "../../utils";
import dayjsTZ from "../../utils/dayjs";

export const colDefs = ({
  categories,
  isMobileView,
  setOpenReplies,
  customCols = [],
  setOpenEditModal,
}) => {
  return [
    {
      headerName: "Titulli",
      field: "announcementTitle",
      sortable: true,
      filter: true,
      width: 200,
      mobile: true,
      isExported: true,
      isCollapseTitle: true,
    },
    {
      headerName: "Kategoria",
      field: "announcementCategory",
      sortable: true,
      filter: true,
      width: 200,
      mobile: true,
      isExported: true,
      valueGetter: ({ data }) =>
        categories[data?.announcementCategory]
          ? categories[data?.announcementCategory]
          : "",
      cellRenderer: ({ value, node }) => (node.group ? null : value),
    },
    {
      headerName: "Përmbajtja",
      field: "announcementBody",
      sortable: true,
      filter: true,
      width: 200,
      mobile: true,
      isExported: true,
      valueGetter: ({ data }) =>
        data?.announcementBody
          ? extractTextFromChildren(
              <>{htmlParser(data?.announcementBody)}</>,
              true
            )
          : "",
      cellRenderer: ({ data, node }) =>
        node.group ? null : htmlParser(data?.announcementBody),
    },
    {
      headerName: "Url",
      field: "announcementUrl",
      sortable: true,
      filter: true,
      width: 200,
    },
    {
      headerName: "Krijuar në",
      field: "createdAt",
      sort: "desc",
      filter: "agDateColumnFilter",
      mobile: true,
      isExported: true,
      format: "DD/MM/YYYY",
      filterParams: {
        apply: true,
        newRowsAction: "keep",
        inRangeInclusive: true,
      },
      valueFormatter: ({ node, value }) =>
        node.group && value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : "",
      keyCreator: ({ value }) =>
        value ? dayjsTZ(value).format("DD/MM/YYYY") : "",
      valueGetter: ({ data }) =>
        data?.createdAt ? dayjsTZ(data.createdAt).toDate() : null,
      cellRenderer: ({ data }) =>
        data?.createdAt ? dayjsTZ(data.createdAt).format("DD/MM/YYYY") : "",
    },

    {
      headerName: "Krijuar Nga",
      field: "createdBy",
      sortable: true,
      filter: true,
      mobile: true,
      isExported: true,
      width: 200,
    },
    {
      headerName: "Përgjigjet",
      field: "usersResponses",
      sortable: true,
      filter: true,
      width: 200,
      mobile: true,
      suppressExcelExport: true,
      isExported: true,
      valueGetter: null,
      cellRenderer: ({ data, node }) => {
        if (node.group) return null;

        if (isMobileView) {
          return (
            <>
              {Object.entries(data.groupedResponses || {}).map(([key, obj]) => (
                <span>
                  {[key]}: {Object.keys(obj).length}
                </span>
              ))}
            </>
          );
        }
        const hasData = Object.keys(data.usersResponses || {}).length;
        return (
          <div className="userResponses">
            <span
              style={{
                color: "#fff",
                backgroundColor: "#1da193",
                cursor: hasData ? "pointer" : "not-allowed",
              }}
              onClick={hasData ? () => setOpenReplies({ record: data }) : null}
            >
              {hasData}
            </span>
            <span
              style={{
                backgroundColor: "#1da193",
                cursor: hasData ? "pointer" : "not-allowed",
              }}
              onClick={() => setOpenEditModal(data)}
            >
              <IconEditWhite height={15} width={15} />
            </span>
          </div>
        );
      },
    },
  ].concat(
    customCols.map((el) => ({
      ...el,
      sortable: true,
      filter: true,
      width: el?.width || 200,
    }))
  );
};
